/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import PropTypes from 'prop-types';

import {Icon as BaseIcon} from '@chakra-ui/react';

import {Box} from '@salesforce/retail-react-app/app/components/shared/ui';

/**
 * @param {{component: object}} args
 *
 * @returns {React.ReactElement}
 */
export function Icon({className = '', ...props}) {
  const {id, provider, modifiers = {}, ...rest} = props;
  let renderAs = BaseIcon;

  if (provider === 'Font Awesome') {
    className = [...new Set(`fa fa-${id}`.split(/\s+/).concat(Object.values(modifiers)).concat(className.split(/\s+/)))].join(' ').trim();
    renderAs = 'i';
  }

  return <Box as={renderAs} className={className} {...rest} />;
}

Icon.displayName = 'Icon';
Icon.propTypes = {
  ...BaseIcon.propTypes,
  className: PropTypes.string,
};
